import { api } from './dynamic-environment';

export const environment = {
  production: api.production,
  envLabel: api.envLabel,
  stripe_token: "STRIPE_TOKEN",
  paypal_token: "PAYPAL_TOKEN",
  disableSettings: false,

  CANDIDATE_APIS: {
    createProfile:
      api.HOST_URI + api.URI_PREFIX + "candidateResumes/createProfile",
    getCountries: api.HOST_URI + api.URI_PREFIX + "countryMaster/getCountries",
    emailVerification:
      api.HOST_URI + api.URI_PREFIX + "users/emailVerification",
    createSubscription:
      api.HOST_URI + api.URI_PREFIX + "subscribe/createSubscription",
    forgotPassword: api.HOST_URI + api.URI_PREFIX + "users/forgotPassword",
    createJobPosting_XX:
      api.HOST_URI + api.URI_PREFIX + "jobPosting/createJobPosting",
    getAllJobPostings:
      api.HOST_URI + api.URI_PREFIX + "jobPosting/getAllJobPostings",
    updateJobPosting_XX:
      api.HOST_URI + api.URI_PREFIX + "jobPosting/updateJobPosting",
    createJobPosting:
      api.HOST_URI + api.URI_PREFIX + "admin/jobPostings/createJobPosting",
    updateJobPosting:
      api.HOST_URI + api.URI_PREFIX + "jobPostings/updateJobPosting",
    validateUser: api.HOST_URI + api.URI_PREFIX + "users/validateUser",
    changePassword: api.HOST_URI + api.URI_PREFIX + "users/changePassword",
    getAllResumes:
      api.HOST_URI + api.URI_PREFIX + "candidateResumes/getAllResumes",
    getAdminDashboard:
      api.HOST_URI + api.URI_PREFIX + "users/getAdminDashboard",
    createEvent: api.HOST_URI + api.URI_PREFIX + "admin/events/createEvent",
    getAllEvents: api.HOST_URI + api.URI_PREFIX + "admin/events/getAllEvents",
    updateEvent: api.HOST_URI + api.URI_PREFIX + "admin/events/updateEvent",
    deleteEvent: api.HOST_URI + api.URI_PREFIX + "admin/events/deleteEvent",
    updateProfile:
      api.HOST_URI + api.URI_PREFIX + "candidateResumes/updateProfile",
    getAllJobs: api.HOST_URI + api.URI_PREFIX + "jobs/getAllJobs",
    getActiveFaqs: api.HOST_URI + api.URI_PREFIX + "user/getActiveFaqs",
    createContactUs: api.HOST_URI + api.URI_PREFIX + "users/createContactUs",
    getAllQualifications: api.HOST_URI + api.URI_PREFIX + "user/getAllQualifications",
    getUserIndustries: api.HOST_URI + api.URI_PREFIX + "user/getUserIndustries",
    getAllDesignations: api.HOST_URI + api.URI_PREFIX + "user/getAllDesignations",
    getCandidateQuestionPaperByExamCode: api.HOST_URI + api.URI_PREFIX + "user/interview/getCandidateQuestionPaperByExamCode",
    validateUserOnlineExam: api.HOST_URI + api.URI_PREFIX + "user/interview/validateUserOnlineExam",
    getAnonymousCandidateQuestionPaperByExamCode: api.HOST_URI + api.URI_PREFIX + "user/interview/getAnonymousCandidateQuestionPaperByExamCode",
    getSimilarJobs: api.HOST_URI + api.URI_PREFIX + "jobs/getSimilarJobs",

  },
  getAllResumes:
    api.HOST_URI + api.URI_PREFIX + "candidateResumes/getAllResumes",
  getAdminDashboard: api.HOST_URI + api.URI_PREFIX + "users/getAdminDashboard",

  ADMIN_APIS: {
    validateAdmin: api.HOST_URI + api.URI_PREFIX + "admin/validateAdmin",
    getUserAgents: api.HOST_URI + api.URI_PREFIX + "admin/getUserAgents",
    createJobPosting:
      api.HOST_URI + api.URI_PREFIX + "admin/jobPostings/createJobPosting",
    updateJobPosting:
      api.HOST_URI + api.URI_PREFIX + "admin/jobPostings/updateJobPosting",

    // Business Sectors
    createBusinessType:
      api.HOST_URI + api.URI_PREFIX + "admin/businessType/createBusinessType",
    updateBusinessType:
      api.HOST_URI + api.URI_PREFIX + "admin/businessType/updateBusinessType",
    getAllBusinessType:
      api.HOST_URI + api.URI_PREFIX + "admin/businessType/getAllBusinessType",
    deleteBusinessType:
      api.HOST_URI + api.URI_PREFIX + "admin/businessType/deleteBusinessType",

    // plans
    createPlans: api.HOST_URI + api.URI_PREFIX + "admin/plans/createPlans",
    getAllPlans: api.HOST_URI + api.URI_PREFIX + "admin/plans/getAllPlans",
    updatePlan: api.HOST_URI + api.URI_PREFIX + "admin/plans/updatePlan",
    deletePlan: api.HOST_URI + api.URI_PREFIX + "admin/plans/deletePlan",
    getPlans: api.HOST_URI + api.URI_PREFIX + "admin/plans/getPlans",
    getDisputes: api.HOST_URI + api.URI_PREFIX + "admin/plans/getDisputes",
    paymentDisputes: api.HOST_URI + api.URI_PREFIX + "admin/plans/paymentDisputes",

    //matri-plans
    createMatiPlan: api.HOST_URI + api.URI_PREFIX + "admin/plans/createMatiPlan",
    getAllMatriPlans: api.HOST_URI + api.URI_PREFIX + "admin/plans/getAllMatriPlans",
    deleteMatriPlan: api.HOST_URI + api.URI_PREFIX + "admin/plans/deleteMatriPlan",
    updateMatiPlan: api.HOST_URI + api.URI_PREFIX + "admin/plans/updateMatiPlan",

    // plans module
    createAppModuleMaster:
      api.HOST_URI + api.URI_PREFIX + "admin/appModule/createAppModuleMaster",
    getAppModuleMaster:
      api.HOST_URI + api.URI_PREFIX + "admin/appModule/getAppModuleMaster",
    updateAppModuleMaster:
      api.HOST_URI + api.URI_PREFIX + "admin/appModule/updateAppModuleMaster",
    deleteAppModuleMaster: api.HOST_URI + api.URI_PREFIX + "admin/appModule/deleteAppModuleMaster",

    //  jobs
    updateJobPostingStatus:
      api.HOST_URI +
      api.URI_PREFIX +
      "admin/jobPostings/updateJobPostingStatus",
    getAllAppliedJobs:
      api.HOST_URI + api.URI_PREFIX + "admin/jobPostings/getAllAppliedJobs",
    getAllJobs: api.HOST_URI + api.URI_PREFIX + "admin/jobPostings/getAllJobs",
    appliedJobs:
      api.HOST_URI + api.URI_PREFIX + "admin/jobPostings/appliedJobs",
    getAllResumes:
      api.HOST_URI + api.URI_PREFIX + "admin/jobPostings/getAllResumes",

    // language
    createLanguage:
      api.HOST_URI + api.URI_PREFIX + "admin/languages/createLanguage",
    getAllLanguages:
      api.HOST_URI + api.URI_PREFIX + "admin/languages/getAllLanguages",
    updateLanguage:
      api.HOST_URI + api.URI_PREFIX + "admin/languages/updateLanguage",
    deleteLanguage: api.HOST_URI + api.URI_PREFIX + "admin/languages/deleteLanguage",
    getUserLangauges: api.HOST_URI + api.URI_PREFIX + "user/getUserLangauges",

    // vendors
    createVendor:
      api.HOST_URI + api.URI_PREFIX + "admin/vendorMaster/createVendor",
    getVendor: api.HOST_URI + api.URI_PREFIX + "admin/vendorMaster/getVendor",
    uploadCompanyLogo:
      api.HOST_URI + api.URI_PREFIX + "admin/vendorMaster/uploadCompanyLogo",
    deleteVendor:
      api.HOST_URI + api.URI_PREFIX + "admin/vendorMaster/deleteVendor",
    updateVendor:
      api.HOST_URI + api.URI_PREFIX + "admin/vendorMaster/updateVendor",

    // resume
    downloadResume: api.HOST_URI + api.URI_PREFIX + "jobs/downloadResume",

    // qualification
    createQualification:
      api.HOST_URI +
      api.URI_PREFIX +
      "admin/qualifications/createQualification",
    getAllQualification:
      api.HOST_URI +
      api.URI_PREFIX +
      "admin/qualifications/getAllQualification",
    updateQualification:
      api.HOST_URI +
      api.URI_PREFIX +
      "admin/qualifications/updateQualification",
    deleteQualification:
      api.HOST_URI +
      api.URI_PREFIX +
      "admin/qualifications/deleteQualification",

    // Industry
    createIndustry:
      api.HOST_URI + api.URI_PREFIX + "admin/industry/createIndustry",
    getAllIndustries:
      api.HOST_URI + api.URI_PREFIX + "admin/industry/getAllIndustries",
    deleteIndustry:
      api.HOST_URI + api.URI_PREFIX + "admin/industry/deleteIndustry",
    updateIndustry:
      api.HOST_URI + api.URI_PREFIX + "admin/industry/updateIndustry",

    // admin_changePassword
    changePassword: api.HOST_URI + api.URI_PREFIX + "admin/changePassword",

    // support
    getAllSupports:
      api.HOST_URI + api.URI_PREFIX + "admin/dashboardSliders/getAllSupports",
    //  feedback
    getAllFeedbacks:
      api.HOST_URI + api.URI_PREFIX + "admin/dashboardSliders/getAllFeedbacks",
    // get count for cards
    getAdminDashboard:
      api.HOST_URI + api.URI_PREFIX + "admin/getAdminDashboard",

    // country
    createCountry: api.HOST_URI + api.URI_PREFIX + "admin/country/createCountry",
    getCountries: api.HOST_URI + api.URI_PREFIX + "user/country/getCountries",
    updateCountry: api.HOST_URI + api.URI_PREFIX + "admin/country/updateCountry",
    deleteCountry: api.HOST_URI + api.URI_PREFIX + "admin/country/deleteCountry",
    getStatesByCountryId: api.HOST_URI + api.URI_PREFIX + "stateMaster/getStatesByCountryId",

    // state
    getStates: api.HOST_URI + api.URI_PREFIX + "stateMaster/getStates",
    createStateMaster: api.HOST_URI + api.URI_PREFIX + "stateMaster/createStateMaster",
    updateState: api.HOST_URI + api.URI_PREFIX + "stateMaster/updateState",
    deleteState: api.HOST_URI + api.URI_PREFIX + "stateMaster/deleteState",
    getCitiesByStateId: api.HOST_URI + api.URI_PREFIX + "cityMaster/getCitiesByStateId",
    getCitiesByStateCode: api.HOST_URI + api.URI_PREFIX + "cityMaster/getCitiesByStateCode",

    // city
    getCities: api.HOST_URI + api.URI_PREFIX + "cityMaster/getCities",
    createCityMaster: api.HOST_URI + api.URI_PREFIX + "cityMaster/createCityMaster",
    deleteCity: api.HOST_URI + api.URI_PREFIX + "cityMaster/deleteCity",
    updateCity: api.HOST_URI + api.URI_PREFIX + "cityMaster/updateCity",

    // religion
    getAllReligions: api.HOST_URI + api.URI_PREFIX + "admin/religion/getAllReligions",
    createReligion: api.HOST_URI + api.URI_PREFIX + "admin/religion/createReligion",
    deleteReligion: api.HOST_URI + api.URI_PREFIX + "admin/religion/deleteReligion",
    updateReligion: api.HOST_URI + api.URI_PREFIX + "admin/religion/updateReligion",

    // caste
    getAllCastes: api.HOST_URI + api.URI_PREFIX + "admin/caste/getAllCastes",
    createCaste: api.HOST_URI + api.URI_PREFIX + "admin/caste/createCaste",
    updateCaste: api.HOST_URI + api.URI_PREFIX + "admin/caste/updateCaste",
    deleteCaste: api.HOST_URI + api.URI_PREFIX + "admin/caste/deleteCaste",

    // designation
    getAllDesignations: api.HOST_URI + api.URI_PREFIX + "admin/designation/getAllDesignations",
    createDesignation: api.HOST_URI + api.URI_PREFIX + "admin/designation/createDesignation",
    updateDesignation: api.HOST_URI + api.URI_PREFIX + "admin/designation/updateDesignation",
    deleteDesignation: api.HOST_URI + api.URI_PREFIX + "admin/designation/deleteDesignation",

    // denominations
    getAllChurchDenominations: api.HOST_URI + api.URI_PREFIX + "admin/churchDenomination/getAllChurchDenominations",
    createChurchDenomination: api.HOST_URI + api.URI_PREFIX + "admin/churchDenomination/createChurchDenomination",
    updateChurchDenomination: api.HOST_URI + api.URI_PREFIX + "admin/churchDenomination/updateChurchDenomination",
    deleteChurchDenomination: api.HOST_URI + api.URI_PREFIX + "admin/churchDenomination/deleteChurchDenomination",

    //
    getAllVendors: api.HOST_URI + api.URI_PREFIX + "admin/vendorMaster/getAllVendors",
    getAllChurches: api.HOST_URI + api.URI_PREFIX + "admin/vendorMaster/getAllChurches",

    //  employement
    getAllEmployeements: api.HOST_URI + api.URI_PREFIX + "admin/employeement/getAllEmployeements",
    createEmployeement: api.HOST_URI + api.URI_PREFIX + "admin/employeement/createEmployeement",
    updateEmployeement: api.HOST_URI + api.URI_PREFIX + "admin/employeement/updateEmployeement",
    deleteEmployeement: api.HOST_URI + api.URI_PREFIX + "admin/employeement/deleteEmployeement",


    // jobtype
    getAllJobType: api.HOST_URI + api.URI_PREFIX + "admin/jobType/getAllJobType",
    createJobType: api.HOST_URI + api.URI_PREFIX + "admin/jobType/createJobType",
    deleteJobType: api.HOST_URI + api.URI_PREFIX + "admin/jobType/deleteJobType",
    updateJobType: api.HOST_URI + api.URI_PREFIX + "admin/jobType/updateJobType",

    // payment << transactions
    getTransaction: api.HOST_URI + api.URI_PREFIX + "admin/getTransaction",

    // orders
    getOrders: api.HOST_URI + api.URI_PREFIX + "admin/getOrders",
    getForbiddenWords: api.HOST_URI + api.URI_PREFIX + "admin/getForbiddenWords",
    createForbiddenWords: api.HOST_URI + api.URI_PREFIX + "admin/createForbiddenWords",
    // admin/jobType/createJobType

    // FAQs
    createFaq: api.HOST_URI + api.URI_PREFIX + "admin/createFaq",
    getAllFaqs: api.HOST_URI + api.URI_PREFIX + "admin/getAllFaqs",
    updateFaq: api.HOST_URI + api.URI_PREFIX + "admin/updateFaq",
    deleteFaq: api.HOST_URI + api.URI_PREFIX + "admin/deleteFaq",

    // Hobbies
    getHobbies: api.HOST_URI + api.URI_PREFIX + "admin/getHobbies",
    deleteHobby: api.HOST_URI + api.URI_PREFIX + "admin/deleteHobby",
    updateHobby: api.HOST_URI + api.URI_PREFIX + "admin/updateHobby",
    createHobby: api.HOST_URI + api.URI_PREFIX + "admin/createHobby",

    // body type
    createBodyType: api.HOST_URI + api.URI_PREFIX + "admin/createBodyType",
    updateBodyType: api.HOST_URI + api.URI_PREFIX + "admin/updateBodyType",
    deleteBodyType: api.HOST_URI + api.URI_PREFIX + "admin/deleteBodyType",
    getAllBodyType: api.HOST_URI + api.URI_PREFIX + "admin/getAllBodyType",

    // occupation
    createOccupation: api.HOST_URI + api.URI_PREFIX + "admin/occupationMaster/createOccupation",
    updateOccupation: api.HOST_URI + api.URI_PREFIX + "admin/occupationMaster/updateOccupation",
    deleteOccupation: api.HOST_URI + api.URI_PREFIX + "admin/occupationMaster/deleteOccupation",
    getAllOccupation: api.HOST_URI + api.URI_PREFIX + "admin/occupationMaster/getAllOccupation",
    userGetAllOccupation: api.HOST_URI + api.URI_PREFIX + "user/matrimonial/getAllOccupation",


    //shop
    createCategory: api.HOST_URI + api.URI_PREFIX + "admin/shop/createCategory",
    updateCategory: api.HOST_URI + api.URI_PREFIX + "admin/shop/updateCategory",
    getCategories: api.HOST_URI + api.URI_PREFIX + "admin/shop/getCategories",
    deleteCategory: api.HOST_URI + api.URI_PREFIX + "admin/shop/deleteCategory",

    // variants
    getAllVariantType: api.HOST_URI + api.URI_PREFIX + "admin/shop/getAllVariantType",
    createVariantType: api.HOST_URI + api.URI_PREFIX + "admin/shop/createVariantType",
    updateVariantType: api.HOST_URI + api.URI_PREFIX + "admin/shop/updateVariantType",
    deleteVariantType: api.HOST_URI + api.URI_PREFIX + "admin/shop/deleteVariantType",

    // Sub Variants
    createVariantSubType: api.HOST_URI + api.URI_PREFIX + "admin/shop/createVariantSubType",
    getAllVariantSubType: api.HOST_URI + api.URI_PREFIX + "admin/shop/getAllVariantSubType",
    updateVariantSubType: api.HOST_URI + api.URI_PREFIX + "admin/shop/updateVariantSubType",
    deleteVariantSubType: api.HOST_URI + api.URI_PREFIX + "admin/shop/deleteVariantSubType",
    // jobpostings
    createJobPosition: api.HOST_URI + api.URI_PREFIX + "admin/jobPostings/createJobPosition",
    updateJobPosition: api.HOST_URI + api.URI_PREFIX + "admin/jobPostings/updateJobPosition",
    deleteJobPosition: api.HOST_URI + api.URI_PREFIX + "admin/jobPostings/deleteJobPosition",
    getAllJobPositions: api.HOST_URI + api.URI_PREFIX + "admin/jobPostings/getAllJobPositions",
    getUserIndustries: api.HOST_URI + api.URI_PREFIX + "user/getUserIndustries",
    //Job DB Plans
    createDbPlans: api.HOST_URI + api.URI_PREFIX + "admin/plans/createDbPlans",
    updateDbPlan: api.HOST_URI + api.URI_PREFIX + "admin/plans/updateDbPlan",
    deleteDbPlan: api.HOST_URI + api.URI_PREFIX + "admin/plans/deleteDbPlan",
    getDbPlans: api.HOST_URI + api.URI_PREFIX + "admin/plans/getDbPlans",

    createAdvertPlans: api.HOST_URI + api.URI_PREFIX + "admin/plans/createAdvertPlans",
    updateAdvertPlan: api.HOST_URI + api.URI_PREFIX + "admin/plans/updateAdvertPlan",
    deleteAdvertPlan: api.HOST_URI + api.URI_PREFIX + "admin/plans/deleteAdvertPlan",
    getAllAdvertPlans: api.HOST_URI + api.URI_PREFIX + "admin/plans/getAllAdvertPlans",

    adminRegistration: api.HOST_URI + api.URI_PREFIX + "admin/adminRegistration",
    getAllAdmins: api.HOST_URI + api.URI_PREFIX + "admin/getAllAdmins",
    createTicketType: api.HOST_URI + api.URI_PREFIX + "admin/createTicketType",
    getAllTicketType: api.HOST_URI + api.URI_PREFIX + "admin/getAllTicketType",
    updateTicketType: api.HOST_URI + api.URI_PREFIX + "admin/updateTicketType",
    supportTicketReply: api.HOST_URI + api.URI_PREFIX + "shared/support/supportTicketReply",
    getSupportTickets: api.HOST_URI + api.URI_PREFIX + "admin/getSupportTickets",
    // Agents
    agentforgotPassword: api.HOST_URI + api.URI_PREFIX + "agents/agentforgotPassword",
    agentChangePassword: api.HOST_URI + api.URI_PREFIX + "agents/agentChangePassword",
    updateAgentDetails: api.HOST_URI + api.URI_PREFIX + "agents/updateAgentDetails",
    validateAgent: api.HOST_URI + api.URI_PREFIX + "agents/validateAgent",
    getAgentDetails: api.HOST_URI + api.URI_PREFIX + "agents/getAgentDetails",
    getAgentReferalAmount: api.HOST_URI + api.URI_PREFIX + "agents/getAgentReferalAmount",
    uploadAgentProfilePic: api.HOST_URI + api.URI_PREFIX + "agents/uploadAgentProfilePic",
    updateBusinessPartnerBankDetails: api.HOST_URI + api.URI_PREFIX + "agents/updateBusinessPartnerBankDetails",
    createBusinessPartnerBankDetails: api.HOST_URI + api.URI_PREFIX + "agents/createBusinessPartnerBankDetails",
    emailBusinessPartnerVerification: api.HOST_URI + api.URI_PREFIX + "agents/emailBusinessPartnerVerification",
    getAllBusinessPartnerBankDetails: api.HOST_URI + api.URI_PREFIX + "agents/getAllBusinessPartnerBankDetails",

    createHealthTip: api.HOST_URI + api.URI_PREFIX + "admin/createHealthTip",
    getAllHealthTips: api.HOST_URI + api.URI_PREFIX + "admin/getAllHealthTips",
    deleteHealthTip: api.HOST_URI + api.URI_PREFIX + "admin/deleteHealthTip",
    getLatestNewsAPI: api.HOST_URI + api.URI_PREFIX + "admin/getLatestNewsAPI",
    publishNews: api.HOST_URI + api.URI_PREFIX + "admin/publishNews",
    getPublisedNews: api.HOST_URI + api.URI_PREFIX + "admin/getPublisedNews",
    unPublishNews: api.HOST_URI + api.URI_PREFIX + "admin/unPublishNews",
    updateHealthTip: api.HOST_URI + api.URI_PREFIX + "admin/updateHealthTip",
    getAllAgents: api.HOST_URI + api.URI_PREFIX + "admin/getAllAgents",
    getActiveFaqs: api.HOST_URI + api.URI_PREFIX + "user/getActiveFaqs",
    createVideo: api.HOST_URI + api.URI_PREFIX + "admin/createVideo",
    getAllVideos: api.HOST_URI + api.URI_PREFIX + "admin/getAllVideos",
    updateVideo: api.HOST_URI + api.URI_PREFIX + "admin/updateVideo",
    deleteVideo: api.HOST_URI + api.URI_PREFIX + "admin/deleteVideo",

    createPolicy: api.HOST_URI + api.URI_PREFIX + "admin/createPolicy",
    getPolicy: api.HOST_URI + api.URI_PREFIX + "admin/getPolicy",
    updatePolicy: api.HOST_URI + api.URI_PREFIX + "admin/updatePolicy",
    deletePolicy: api.HOST_URI + api.URI_PREFIX + "admin/deletePolicy",
    updateVendorStatus: api.HOST_URI + api.URI_PREFIX + "admin/updateVendorStatus",
    getAllAdminJobAdverts: api.HOST_URI + api.URI_PREFIX + "admin/jobPostings/getAllAdminJobAdverts",
    deleteAdminJobAdverts: api.HOST_URI + api.URI_PREFIX + "admin/jobPostings/deleteAdminJobAdverts",
    updateAdminJobAdverts: api.HOST_URI + api.URI_PREFIX + "admin/jobPostings/updateAdminJobAdverts",
    createAdminJobAdverts: api.HOST_URI + api.URI_PREFIX + "admin/jobPostings/createAdminJobAdverts",
    uploadAdminAdvertsImage: api.HOST_URI + api.URI_PREFIX + "admin/jobPostings/uploadAdminAdvertsImage",
    uploadBlogImage: api.HOST_URI + api.URI_PREFIX + "admin/blogs/uploadBlogImage",
    createBlog: api.HOST_URI + api.URI_PREFIX + "admin/blogs/createBlog",
    getAllBlogs: api.HOST_URI + api.URI_PREFIX + "admin/blogs/getAllBlogs",
    updateBlogById: api.HOST_URI + api.URI_PREFIX + "admin/blogs/updateBlogById",
    deleteBlogById: api.HOST_URI + api.URI_PREFIX + "admin/blogs/deleteBlogById",
    getBlogBySlugName: api.HOST_URI + api.URI_PREFIX + "users/getBlogBySlugName",
    createPlansLabel: api.HOST_URI + api.URI_PREFIX + "admin/createPlansLabel",
    getAllPlansLabel: api.HOST_URI + api.URI_PREFIX + "admin/getAllPlansLabel",
    updatePlansLabel: api.HOST_URI + api.URI_PREFIX + "admin/updatePlansLabel",
    deletePlansLabel: api.HOST_URI + api.URI_PREFIX + "admin/deletePlansLabel",
    createReportCategory: api.HOST_URI + api.URI_PREFIX + "admin/qualifications/createReportCategory",
    getAllReportCategories: api.HOST_URI + api.URI_PREFIX + "admin/qualifications/getAllReportCategories",
    updateReportCategory: api.HOST_URI + api.URI_PREFIX + "admin/qualifications/updateReportCategory",
    deleteReportCategory: api.HOST_URI + api.URI_PREFIX + "admin/qualifications/deleteReportCategory",
    getStatesByCountryCode: api.HOST_URI + api.URI_PREFIX + "stateMaster/getStatesByCountryCode",

    createPlanType: api.HOST_URI + api.URI_PREFIX + "admin/plans/createPlanType",
    updatePlanType: api.HOST_URI + api.URI_PREFIX + "admin/plans/updatePlanType",
    getPlansType: api.HOST_URI + api.URI_PREFIX + "admin/plans/getPlansType",
    deletePlanType: api.HOST_URI + api.URI_PREFIX + "admin/plans/deletePlanType",

    createPlanComparison: api.HOST_URI + api.URI_PREFIX + "admin/plans/createPlanComparison",
    updatePlanComparison: api.HOST_URI + api.URI_PREFIX + "admin/plans/updatePlanComparison",
    getPlansComparison: api.HOST_URI + api.URI_PREFIX + "admin/plans/getPlansComparison",
    deletePlanComparison: api.HOST_URI + api.URI_PREFIX + "admin/plans/deletePlanComparison",
    createBankDetails: api.HOST_URI + api.URI_PREFIX + "shared/bankDetails/createBankDetails",
    getBankDetails: api.HOST_URI + api.URI_PREFIX + "shared/bankDetails/getBankDetails",
    updateBankDetails: api.HOST_URI + api.URI_PREFIX + "shared/bankDetails/updateBankDetails",

    createDocuments: api.HOST_URI + api.URI_PREFIX + "shared/createDocuments",
    getDocumentsById: api.HOST_URI + api.URI_PREFIX + "shared/getDocumentsById",
    deleteDocuments: api.HOST_URI + api.URI_PREFIX + "shared/deleteDocuments",

    getAbbrivations: api.HOST_URI + api.URI_PREFIX + "admin/getAbbrivations",
    createAbbrivation: api.HOST_URI + api.URI_PREFIX + "admin/createAbbrivation",
    updateAbbrivation: api.HOST_URI + api.URI_PREFIX + "admin/updateAbbrivation",
    getDemo: api.HOST_URI + api.URI_PREFIX + "shared/demo/getDemo",
    createPlanPriority: api.HOST_URI + api.URI_PREFIX + "admin/plans/createPlanPriority",
    updatePlanComparisonPriority: api.HOST_URI + api.URI_PREFIX + "admin/plans/updatePlanComparisonPriority",
    getReferralBonusData: api.HOST_URI + api.URI_PREFIX + "admin/getReferralBonusData",
    updateTransactionStatus: api.HOST_URI + api.URI_PREFIX + "admin/updateTransactionStatus",
    updateVendorApplication: api.HOST_URI + api.URI_PREFIX + "admin/vendorMaster/updateVendorApplication",
    getJobPlanFeatures: api.HOST_URI + api.URI_PREFIX + "admin/plans/getJobPlanFeatures",
    updateJobPlanFeatures: api.HOST_URI + api.URI_PREFIX + "admin/plans/updateJobPlanFeatures",
    getPlanCompareFeaturesByModule: api.HOST_URI + api.URI_PREFIX + "admin/plans/getPlanCompareFeaturesByModule",
    getMatriPlanFeatures: api.HOST_URI + api.URI_PREFIX + "admin/plans/getMatriPlanFeatures",
    updateMatriPlanFeatures: api.HOST_URI + api.URI_PREFIX + "admin/plans/updateMatriPlanFeatures",
    getAllCountries: api.HOST_URI + api.URI_PREFIX + "admin/country/getAllCountries",
    getAdvertPlanFeatures: api.HOST_URI + api.URI_PREFIX + "admin/plans/getAdvertPlanFeatures",
    getDbPlanFeatures: api.HOST_URI + api.URI_PREFIX + "admin/plans/getDbPlanFeatures",
    updateDbPlanFeatures: api.HOST_URI + api.URI_PREFIX + "admin/plans/updateDbPlanFeatures",
    updateAdvertPlanFeatures: api.HOST_URI + api.URI_PREFIX + "admin/plans/updateAdvertPlanFeatures",
    getTransactionPlanFeatures: api.HOST_URI + api.URI_PREFIX + "admin/getTransactionPlanFeatures",
    createCoupon: api.HOST_URI + api.URI_PREFIX + "admin/createCoupon",
    getAllCoupons: api.HOST_URI + api.URI_PREFIX + "admin/getAllCoupons",
    updateCoupon: api.HOST_URI + api.URI_PREFIX + "admin/updateCoupon",
    deleteCoupon: api.HOST_URI + api.URI_PREFIX + "admin/deleteCoupon",
    createVisaType: api.HOST_URI + api.URI_PREFIX + "admin/createVisaType",
    updateVisaType: api.HOST_URI + api.URI_PREFIX + "admin/updateVisaType",
    getAllVisaType: api.HOST_URI + api.URI_PREFIX + "admin/getAllVisaType",
    deleteVisaType: api.HOST_URI + api.URI_PREFIX + "admin/deleteVisaType",
    createWhatsapp: api.HOST_URI + api.URI_PREFIX + "admin/createWhatsapp",
    getWhatsapp: api.HOST_URI + api.URI_PREFIX + "admin/getWhatsapp",
    updateWhatsapp: api.HOST_URI + api.URI_PREFIX + "admin/updateWhatsapp",
    deleteWhatsapp: api.HOST_URI + api.URI_PREFIX + "admin/deleteWhatsapp",
    createResumeBuilderPlans: api.HOST_URI + api.URI_PREFIX + "admin/createResumeBuilderPlans",
    getAllResumeBuilderPlans: api.HOST_URI + api.URI_PREFIX + "admin/getAllResumeBuilderPlans",
    deleteResumeBuilderPlans: api.HOST_URI + api.URI_PREFIX + "admin/deleteResumeBuilderPlans",
    updateResumeBuilderPlans: api.HOST_URI + api.URI_PREFIX + "admin/updateResumeBuilderPlans",
    updateResumeBuilderPlanImage: api.HOST_URI + api.URI_PREFIX + "admin/updateResumeBuilderPlanImage",
    getAllResumeScore: api.HOST_URI + api.URI_PREFIX + "admin/getAllResumeScore",
    updateResumeScore: api.HOST_URI + api.URI_PREFIX + "admin/updateResumeScore",
    createResumeScore: api.HOST_URI + api.URI_PREFIX + "admin/createResumeScore",
    deleteResumeScore: api.HOST_URI + api.URI_PREFIX + "admin/deleteResumeScore",
    addCarrierAiAssistance: api.HOST_URI + api.URI_PREFIX + "admin/addCarrierAiAssistance",
    getCarrierAiAssistance: api.HOST_URI + api.URI_PREFIX + "admin/getCarrierAiAssistance",
    getAllUsers: api.HOST_URI + api.URI_PREFIX + "admin/getAllUsers",
    updateVendorDocumentStatus: api.HOST_URI + api.URI_PREFIX + "admin/updateVendorDocumentStatus",
    getPendingVendorDocuments: api.HOST_URI + api.URI_PREFIX + "admin/getPendingVendorDocuments",
    getAllContacts: api.HOST_URI + api.URI_PREFIX + "admin/getAllContacts",
    adminReplyToContact: api.HOST_URI + api.URI_PREFIX + "admin/adminReplyToContact",
    createHrmsPlans: api.HOST_URI + api.URI_PREFIX + "admin/plans/createHrmsPlans",
    updateHrmsPlans: api.HOST_URI + api.URI_PREFIX + "admin/plans/updateHrmsPlans",
    getHrmsPlans: api.HOST_URI + api.URI_PREFIX + "admin/plans/getAllHrmsPlans",
    getAllNavigationLinks: api.HOST_URI + api.URI_PREFIX + "admin/getAllNavigationLinks",
    updateNavigationLink: api.HOST_URI + api.URI_PREFIX + "admin/updateNavigationLink",
    createNavigationLink: api.HOST_URI + api.URI_PREFIX + "admin/createNavigationLink",
    deleteNavigationLink: api.HOST_URI + api.URI_PREFIX + "admin/deleteNavigationLink",
    createVendorRmDetails: api.HOST_URI + api.URI_PREFIX + "admin/createVendorRmDetails",

  },

  VENDOR_APIS: {
    vendorRegistration: api.HOST_URI + api.URI_PREFIX + "admin/vendorMaster/vendorRegistration",

    changeEmployeePassword: api.HOST_URI + api.URI_PREFIX + "vendor/employee/changeEmployeePassword",
    employeeForgotPassword: api.HOST_URI + api.URI_PREFIX + "vendor/employee/employeeForgotPassword",
    interviewerForgotPassword: api.HOST_URI + api.URI_PREFIX + "interviewer/interviewerForgotPassword",
    interviewerchangePassword: api.HOST_URI + api.URI_PREFIX + "interviewer/interviewerchangePassword",

    emailVendorVerification: api.HOST_URI + api.URI_PREFIX + "admin/vendorMaster/emailVendorVerification",
    validateVendor: api.HOST_URI + api.URI_PREFIX + "admin/vendorMaster/validateVendor",
    validateEmployee: api.HOST_URI + api.URI_PREFIX + "admin/vendorMaster/validateEmployee",
    updateVendorDetails: api.HOST_URI + api.URI_PREFIX + "vendor/updateVendorDetails",
    uploadProfilePic: api.HOST_URI + api.URI_PREFIX + "vendor/uploadProfilePic",
    forgotPassword: api.HOST_URI + api.URI_PREFIX + "admin/vendorMaster/forgotPassword",
    createChurch: api.HOST_URI + api.URI_PREFIX + "vendor/church/createChurch",
    uploadLogo: api.HOST_URI + api.URI_PREFIX + "vendor/church/uploadLogo",
    updateVendorChurch: api.HOST_URI + api.URI_PREFIX + "vendor/church/updateChurch",
    getVendorProfileById: api.HOST_URI + api.URI_PREFIX + "vendor/getVendorProfileById",

    // getChurches: api.HOST_URI + api.URI_PREFIX + "admin/vendorMaster/getChurches",
    getChurches: api.HOST_URI + api.URI_PREFIX + "vendor/church/getChurches",
    createChurchAddress: api.HOST_URI + api.URI_PREFIX + "vendor/church/createChurchAddress",

    //matrimonial
    createMatrimonialPersonalProfile: api.HOST_URI + api.URI_PREFIX + "vendor/matri/createMatrimonialPersonalProfile",
    updatePersonal: api.HOST_URI + api.URI_PREFIX + "vendor/matri/updatePersonal",
    createPhysical: api.HOST_URI + api.URI_PREFIX + "vendor/matri/createPhysical",
    createEmployment: api.HOST_URI + api.URI_PREFIX + "vendor/matri/createEmployment",
    createMaritalInfo: api.HOST_URI + api.URI_PREFIX + "vendor/matri/createMaritalInfo",
    createPreference: api.HOST_URI + api.URI_PREFIX + "vendor/matri/createPreference",
    createEducation: api.HOST_URI + api.URI_PREFIX + "vendor/matri/createEducation",
    createFamily: api.HOST_URI + api.URI_PREFIX + "vendor/matri/createFamily",
    getMatriProfilesByVendorId: api.HOST_URI + api.URI_PREFIX + "vendor/matri/getMatriProfilesByVendorId",
    createPerference: api.HOST_URI + api.URI_PREFIX + "vendor/matri/createPerference",
    createAddress: api.HOST_URI + api.URI_PREFIX + "vendor/matri/createAddress",
    getMatProfile: api.HOST_URI + api.URI_PREFIX + "vendor/matri/getMatProfile",
    getFilterMatProfiles: api.HOST_URI + api.URI_PREFIX + "vendor/matri/getFilterMatProfiles",
    updateProfilePic: api.HOST_URI + api.URI_PREFIX + "vendor/matrimonial/updateProfilePic",
    getActiveHobbies: api.HOST_URI + api.URI_PREFIX + "user/matrimonial/getActiveHobbies",
    setProfilePicThumbnail: api.HOST_URI + api.URI_PREFIX + "vendor/matrimonial/setProfilePicThumbnail",
    deleteProfilePic: api.HOST_URI + api.URI_PREFIX + "vendor/matrimonial/deleteProfilePic",
    // uploadAvatar: api.HOST_URI + api.URI_PREFIX + "mediaUserFiles/uploadAvatar",
    // createVendorMatriAddress: api.HOST_URI + api.URI_PREFIX + "address/createVendorMatriAddress",

    // matri publish and unpublish
    setMatrimonyProfilePublish: api.HOST_URI + api.URI_PREFIX + "vendor/matri/setMatrimonyProfilePublish",
    setMatrimonyProfileUnPublish: api.HOST_URI + api.URI_PREFIX + "vendor/matri/setMatrimonyProfileUnPublish",

    // Matri Search Filter  
    matriSearchUserProfiles: api.HOST_URI + api.URI_PREFIX + "vendor/matri/matriSearchUserProfiles",
    getPartnerProfileByUuid: api.HOST_URI + api.URI_PREFIX + "vendor/matri/getPartnerProfileByUuid",
    createProfileVisit: api.HOST_URI + api.URI_PREFIX + "vendor/matrimonial/createProfileVisit",
    getProfileYouVisited: api.HOST_URI + api.URI_PREFIX + "vendor/matrimonial/getProfileYouVisited",
    getProfileShortListed: api.HOST_URI + api.URI_PREFIX + "vendor/matrimonial/getProfileShortListed",
    removeProfileShortlisted: api.HOST_URI + api.URI_PREFIX + "vendor/matrimonial/removeProfileShortlisted",
    getBlockedProfiles: api.HOST_URI + api.URI_PREFIX + "vendor/matrimonial/getBlockedProfiles",
    unBlockProfile: api.HOST_URI + api.URI_PREFIX + "vendor/matrimonial/unBlockProfile",
    getProfileMyInterest: api.HOST_URI + api.URI_PREFIX + "vendor/matrimonial/getProfileMyInterest",
    vendorAcceptInterest: api.HOST_URI + api.URI_PREFIX + "vendor/matrimonial/vendorAcceptInterest",
    vendorDeclineInterest: api.HOST_URI + api.URI_PREFIX + "vendor/matrimonial/vendorDeclineInterest",

    // shortlist, interested, blocked
    createProfileInterest: api.HOST_URI + api.URI_PREFIX + "vendor/matrimonial/createProfileInterest",
    createProfileShortlist: api.HOST_URI + api.URI_PREFIX + "vendor/matrimonial/createProfileShortlist",
    createProfileBlocked: api.HOST_URI + api.URI_PREFIX + "vendor/matrimonial/createProfileBlocked",

    // church weekly services
    getAllWeeklyServices: api.HOST_URI + api.URI_PREFIX + "vendor/churchWeeklyServices/getAllWeeklyServices",
    createWeeklyServices: api.HOST_URI + api.URI_PREFIX + "vendor/churchWeeklyServices/createWeeklyServices",
    updateWeeklyServices: api.HOST_URI + api.URI_PREFIX + "vendor/churchWeeklyServices/updateWeeklyServices",
    deleteWeeklyServices: api.HOST_URI + api.URI_PREFIX + "vendor/churchWeeklyServices/deleteWeeklyServices",

    // testimony
    getAllTestimonies: api.HOST_URI + api.URI_PREFIX + "vendor/churches/getAllTestimonies",
    createTestimony: api.HOST_URI + api.URI_PREFIX + "vendor/churches/createTestimony",
    deleteTestimony: api.HOST_URI + api.URI_PREFIX + "vendor/churches/deleteTestimony",
    updateTestimony: api.HOST_URI + api.URI_PREFIX + "vendor/churches/updateTestimony",

    // ministry
    createMinistries: api.HOST_URI + api.URI_PREFIX + "vendor/churchMinistries/createMinistries",
    getAllMinistries: api.HOST_URI + api.URI_PREFIX + "vendor/churchMinistries/getAllMinistries",
    updateMinistry: api.HOST_URI + api.URI_PREFIX + "vendor/churchMinistries/updateMinistry",
    deleteMinistry: api.HOST_URI + api.URI_PREFIX + "vendor/churchMinistries/deleteMinistry",

    // gallery-master
    createGalleryMaster: api.HOST_URI + api.URI_PREFIX + "vendor/churches/createGalleryMaster",
    getAllGalleryMaster: api.HOST_URI + api.URI_PREFIX + "vendor/churches/getAllGalleryMaster",
    updateGalleryMaster: api.HOST_URI + api.URI_PREFIX + "vendor/churches/updateGalleryMaster",
    deleteGalleryMaster: api.HOST_URI + api.URI_PREFIX + "vendor/churches/deleteGalleryMaster",

    // gallery
    createChurchGallery: api.HOST_URI + api.URI_PREFIX + "vendor/churches/createChurchGallery",
    getAllChurchGallery: api.HOST_URI + api.URI_PREFIX + "vendor/churches/getAllChurchGallery",
    updateChurchGallery: api.HOST_URI + api.URI_PREFIX + "vendor/churches/updateChurchGallery",
    deleteChurchGallery: api.HOST_URI + api.URI_PREFIX + "vendor/churches/deleteChurchGallery",

    // church roles
    createChurchRole: api.HOST_URI + api.URI_PREFIX + "vendor/churches/createChurchRole",
    getAllChurchRoles: api.HOST_URI + api.URI_PREFIX + "vendor/churches/getAllChurchRoles",
    updateChurchRoles: api.HOST_URI + api.URI_PREFIX + "vendor/churches/updateChurchRoles",
    deleteChurchRoles: api.HOST_URI + api.URI_PREFIX + "vendor/churches/deleteChurchRoles",

    // daily promises
    getAllChurchDailyPromises: api.HOST_URI + api.URI_PREFIX + "vendor/churches/getAllChurchDailyPromises",
    createChurchDailyPromises: api.HOST_URI + api.URI_PREFIX + "vendor/churches/createChurchDailyPromises",
    updateChurchDailyPromises: api.HOST_URI + api.URI_PREFIX + "vendor/churches/updateChurchDailyPromises",
    deleteChurchDailyPromises: api.HOST_URI + api.URI_PREFIX + "vendor/churches/deleteChurchDailyPromises",

    //razor pay
    initiateOrder: api.HOST_URI + api.URI_PREFIX + "shared/plans/initiateOrder",
    createPurchaseOrder: api.HOST_URI + api.URI_PREFIX + "shared/plans/createPurchaseOrder",
    freePusrchaseOrder: api.HOST_URI + api.URI_PREFIX + "shared/plans/freePusrchaseOrder",


    initiateJobOrder: api.HOST_URI + api.URI_PREFIX + "user/plans/initiateJobOrder",
    createJobPurchageOrder: api.HOST_URI + api.URI_PREFIX + "user/plans/createJobPurchageOrder",

    getAllTransactionOrders: api.HOST_URI + api.URI_PREFIX + "vendor/getAllTransactionOrders",

    createDbPurchageOrder: api.HOST_URI + api.URI_PREFIX + "user/plans/createDbPurchageOrder",
    initiateDbPlansOrder: api.HOST_URI + api.URI_PREFIX + "user/plans/initiateDbPlansOrder",

    initiateAdvertPlansOrder: api.HOST_URI + api.URI_PREFIX + "user/plans/initiateAdvertPlansOrder",
    createAdvertPurchageOrder: api.HOST_URI + api.URI_PREFIX + "user/plans/createAdvertPurchageOrder",

    initiateMatriOrder: api.HOST_URI + api.URI_PREFIX + "user/plans/initiateMatriOrder",
    createPurchageOrderMatri: api.HOST_URI + api.URI_PREFIX + "user/plans/createPurchageOrderMatri",

    // orders
    getOrders: api.HOST_URI + api.URI_PREFIX + "vendor/getOrders",

    // change password
    changePassword: api.HOST_URI + api.URI_PREFIX + "admin/vendorMaster/changePassword",

    // active plans
    getActivePlans: api.HOST_URI + api.URI_PREFIX + "vendor/getActivePlans",

    // vendor company profile

    createVendorDetails: api.HOST_URI + api.URI_PREFIX + "vendor/createVendorDetails",
    uploadCompanyLogo: api.HOST_URI + api.URI_PREFIX + "vendor/uploadCompanyLogo",
    createCompanyDocuments: api.HOST_URI + api.URI_PREFIX + "vendor/companyDocuments/createCompanyDocuments",
    createBureauDocuments: api.HOST_URI + api.URI_PREFIX + "vendor/companyDocuments/createBureauDocuments",
    deleteBureauDocuments: api.HOST_URI + api.URI_PREFIX + "vendor/companyDocuments/deleteBureauDocuments",
    getAllBureauDocuments: api.HOST_URI + api.URI_PREFIX + "vendor/companyDocuments/getAllBureauDocuments",
    getAllCompanyDocuments: api.HOST_URI + api.URI_PREFIX + "vendor/companyDocuments/getAllCompanyDocuments",
    updateCompanySocialLinks: api.HOST_URI + api.URI_PREFIX + "vendor/updateCompanySocialLinks",
    getCompanyDetailsByVendorId: api.HOST_URI + api.URI_PREFIX + "vendor/getCompanyDetailsByVendorId",
    createJobCandRestriction: api.HOST_URI + api.URI_PREFIX + "vendor/createJobCandRestriction",
    createCompanyOrBureauProfileBeforePayment: api.HOST_URI + api.URI_PREFIX + "vendor/createCompanyOrBureauProfileBeforePayment",

    //jobs
    createJobPosting: api.HOST_URI + api.URI_PREFIX + "vendor/createJobPosting",
    getAllJobPostings: api.HOST_URI + api.URI_PREFIX + "vendor/getAllJobPostings",

    // applied jobs
    getAllAppliedJobs: api.HOST_URI + api.URI_PREFIX + "vendor/getAllAppliedJobs",
    getAllJobs: api.HOST_URI + api.URI_PREFIX + "vendor/getAllJobs",
    appliedJobs: api.HOST_URI + api.URI_PREFIX + "vendor/appliedJobs",
    // updateJobPosting: api.HOST_URI + api.URI_PREFIX + "vendor/updateJobPosting",
    deleteJobPosting: api.HOST_URI + api.URI_PREFIX + "vendor/deleteJobPosting",
    getAllJobType: api.HOST_URI + api.URI_PREFIX + "admin/jobType/getAllJobType",


    // vendor support
    createSupportTicket:
      api.HOST_URI + api.URI_PREFIX + "vendor/createSupportTicket",
    getSupportTickets:
      api.HOST_URI + api.URI_PREFIX + "vendor/getSupportTickets",

    // interview schedular
    createInterviewSchedule: api.HOST_URI + api.URI_PREFIX + "vendor/interviewSchedule/createInterviewSchedule",
    updateInterviewSchedule: api.HOST_URI + api.URI_PREFIX + "vendor/interviewSchedule/updateInterviewSchedule",
    getSchedulesByJobId: api.HOST_URI + api.URI_PREFIX + "vendor/interviewSchedule/getSchedulesByJobId",
    interviewerResendMail: api.HOST_URI + api.URI_PREFIX + "vendor/interviewSchedule/interviewerResendMail",

    // recruiter feedback forms
    createInterviewFeedback: api.HOST_URI + api.URI_PREFIX + "vendor/interviewFeedback/createInterviewFeedback",
    getFeedbackByJobId: api.HOST_URI + api.URI_PREFIX + "vendor/interviewFeedback/getFeedbackByJobId",
    generateEmail: api.HOST_URI + api.URI_PREFIX + "shared/jobsEmailCommunication/generateEmail",
    getEmailsByVendorId: api.HOST_URI + api.URI_PREFIX + "shared/jobsEmailCommunication/getEmailsByVendorId",
    getEmailsByVendorIdAndUserId: api.HOST_URI + api.URI_PREFIX + "shared/jobsEmailCommunication/getEmailsByVendorIdAndUserId",

    // Interviwer Modules
    validateInterviewer: api.HOST_URI + api.URI_PREFIX + "interviewer/validateInterviewer",
    getMySchedules: api.HOST_URI + api.URI_PREFIX + "interviewer/getMySchedules",
    getFeedbackForm: api.HOST_URI + api.URI_PREFIX + "interviewer/getFeedbackForm",
    createInterviewAnswers: api.HOST_URI + api.URI_PREFIX + "vendor/answer/createInterviewAnswers",
    deleteScheduleByJobId: api.HOST_URI + api.URI_PREFIX + "vendor/interviewSchedule/deleteScheduleByJobId",
    candidateResendMail: api.HOST_URI + api.URI_PREFIX + "vendor/interviewSchedule/candidateResendMail",

    // consolidate
    getConsolidateForm: api.HOST_URI + api.URI_PREFIX + "vendor/answer/getConsolidateForm",
    vendorFinalReview: api.HOST_URI + api.URI_PREFIX + "vendor/answer/vendorFinalReview",

    // OTP
    generateEmailOTP: api.HOST_URI + api.URI_PREFIX + "vendor/generateEmailOTP",
    validateEmailOTP: api.HOST_URI + api.URI_PREFIX + "vendor/validateEmailOTP",
    generateMobileOTP: api.HOST_URI + api.URI_PREFIX + "vendor/generateMobileOTP",
    validateMobileOTP: api.HOST_URI + api.URI_PREFIX + "vendor/validateMobileOTP",

    //Employee
    createEmployee: api.HOST_URI + api.URI_PREFIX + "vendor/employee/createEmployee",
    uploadEmployeePic: api.HOST_URI + api.URI_PREFIX + "vendor/employee/uploadEmployeePic",
    getAllEmployees: api.HOST_URI + api.URI_PREFIX + "vendor/employee/getAllEmployees",
    deleteEmployee: api.HOST_URI + api.URI_PREFIX + "vendor/employee/deleteEmployee",
    getActiveEmployees: api.HOST_URI + api.URI_PREFIX + "vendor/employee/getActiveEmployees",
    jobReviewStatus: api.HOST_URI + api.URI_PREFIX + "vendor/jobReviewStatus",
    assignEmployee: api.HOST_URI + api.URI_PREFIX + "vendor/assignEmployee",
    generateEmployeeEmailOTP: api.HOST_URI + api.URI_PREFIX + "vendor/employee/generateEmployeeEmailOTP",
    validateEmployeeEmailOTP: api.HOST_URI + api.URI_PREFIX + "vendor/employee/validateEmployeeEmailOTP",
    generateEmployeeMobileOTP: api.HOST_URI + api.URI_PREFIX + "vendor/employee/generateEmployeeMobileOTP",
    validateEmployeeMobileOTP: api.HOST_URI + api.URI_PREFIX + "vendor/employee/validateEmployeeMobileOTP",
    getEmployeeProfileById: api.HOST_URI + api.URI_PREFIX + "vendor/employee/getEmployeeProfileById",
    downloadInvoice: api.HOST_URI + api.URI_PREFIX + "user/plans/downloadInvoice",
    downloadMatriInvoice: api.HOST_URI + api.URI_PREFIX + "user/plans/downloadMatriInvoice",
    downloadDbInvoice: api.HOST_URI + api.URI_PREFIX + "user/plans/downloadDbInvoice",
    downloadAdvertInvoice: api.HOST_URI + api.URI_PREFIX + "user/plans/downloadAdvertInvoice",
    getNoofPDFFiles: api.HOST_URI + api.URI_PREFIX + "getNoofPDFFiles",
    deleteInvoices: api.HOST_URI + api.URI_PREFIX + "deleteInvoices",
    employeeResendMail: api.HOST_URI + api.URI_PREFIX + "vendor/employee/employeeResendMail",

    //shop
    createProduct: api.HOST_URI + api.URI_PREFIX + "vendor/shop/createProduct",
    updateProduct: api.HOST_URI + api.URI_PREFIX + "vendor/shop/updateProduct",
    deleteProduct: api.HOST_URI + api.URI_PREFIX + "vendor/shop/deleteProduct",
    getAllProducts: api.HOST_URI + api.URI_PREFIX + "user/shop/getAllProducts",
    getFilteredProducts: api.HOST_URI + api.URI_PREFIX + "user/shop/getFilteredProducts",

    createProductPhotos: api.HOST_URI + api.URI_PREFIX + "vendor/shop/createProductPhotos",
    updateProductPhotos: api.HOST_URI + api.URI_PREFIX + "vendor/shop/updateProductPhotos",
    getProductPhotos: api.HOST_URI + api.URI_PREFIX + "vendor/shop/getProductPhotos",

    // colors
    createProductColor: api.HOST_URI + api.URI_PREFIX + "vendor/shop/createProductColor",
    updateProductColor: api.HOST_URI + api.URI_PREFIX + "vendor/shop/updateProductColor",
    deleteProductColor: api.HOST_URI + api.URI_PREFIX + "vendor/shop/deleteProductColor",
    getProductColor: api.HOST_URI + api.URI_PREFIX + "vendor/shop/getProductColor",


    // size
    getProductSize: api.HOST_URI + api.URI_PREFIX + "vendor/shop/getProductSize",
    createProductSize: api.HOST_URI + api.URI_PREFIX + "vendor/shop/createProductSize",

    // uom
    createProductUom: api.HOST_URI + api.URI_PREFIX + "vendor/shop/createProductUom",
    updateProductUom: api.HOST_URI + api.URI_PREFIX + "vendor/shop/updateProductUom",
    deleteProductUom: api.HOST_URI + api.URI_PREFIX + "vendor/shop/deleteProductUom",
    getProductUom: api.HOST_URI + api.URI_PREFIX + "vendor/shop/getProductUom",
    createInterviewRound: api.HOST_URI + api.URI_PREFIX + "vendor/interviewSchedule/createInterviewRound",
    getActiveInterviewRound: api.HOST_URI + api.URI_PREFIX + "vendor/interviewSchedule/getActiveInterviewRound",
    updateInterviewRound: api.HOST_URI + api.URI_PREFIX + "vendor/interviewSchedule/updateInterviewRound",
    createJobAdverts: api.HOST_URI + api.URI_PREFIX + "vendor/createJobAdverts",
    getAllJobAdverts: api.HOST_URI + api.URI_PREFIX + "vendor/getAllJobAdverts",
    updateJobAdverts: api.HOST_URI + api.URI_PREFIX + "vendor/updateJobAdverts",
    deleteJobAdverts: api.HOST_URI + api.URI_PREFIX + "vendor/deleteJobAdverts",
    uploadAdvertsImage: api.HOST_URI + api.URI_PREFIX + "vendor/uploadAdvertsImage",
    createExam: api.HOST_URI + api.URI_PREFIX + "exam/createExam",
    updateExam: api.HOST_URI + api.URI_PREFIX + "exam/updateExam",
    getAllQuestions: api.HOST_URI + api.URI_PREFIX + "exam/getAllQuestions",
    createQuestion: api.HOST_URI + api.URI_PREFIX + "exam/createQuestion",
    getAllExam: api.HOST_URI + api.URI_PREFIX + "exam/getAllExam",
    submitExam: api.HOST_URI + api.URI_PREFIX + "exam/submitExam",
    startExam: api.HOST_URI + api.URI_PREFIX + "exam/startExam",
    getActiveJobPostions: api.HOST_URI + api.URI_PREFIX + "vendor/getActiveJobPostions",
    getAvailableCandidateProfiles: api.HOST_URI + api.URI_PREFIX + "vendor/getAvailableCandidateProfiles",
    getCandidateProfile: api.HOST_URI + api.URI_PREFIX + "vendor/getCandidateProfile",
    candidateSaveProfile: api.HOST_URI + api.URI_PREFIX + "vendor/candidateSaveProfile",
    getCandidateSavedProfiles: api.HOST_URI + api.URI_PREFIX + "vendor/getCandidateSavedProfiles",
    createJobsAdvertsApplication: api.HOST_URI + api.URI_PREFIX + "vendor/createJobsAdvertsApplication",
    advertsSearchBySlug: api.HOST_URI + api.URI_PREFIX + "user/advertsSearchBySlug",
    appliedAdvertJobs: api.HOST_URI + api.URI_PREFIX + "vendor/appliedAdvertJobs",
    getAllJobAdvertsByVendorId: api.HOST_URI + api.URI_PREFIX + "vendor/getAllJobAdvertsByVendorId",
    createJobInterviewMode: api.HOST_URI + api.URI_PREFIX + "vendor/createJobInterviewMode",
    createJobWorkLocation: api.HOST_URI + api.URI_PREFIX + "vendor/createJobWorkLocation",
    getJobLocationsById: api.HOST_URI + api.URI_PREFIX + "vendor/getJobLocationsById",
    deleteJobLocationByid: api.HOST_URI + api.URI_PREFIX + "vendor/deleteJobLocationByid",
    createVendorCompany: api.HOST_URI + api.URI_PREFIX + "vendor/createVendorCompany",
    updateContactDetails: api.HOST_URI + api.URI_PREFIX + "vendor/updateContactDetails",
    updateCompanyAddress: api.HOST_URI + api.URI_PREFIX + "vendor/updateCompanyAddress",
    createVendorCompanyBranch: api.HOST_URI + api.URI_PREFIX + "vendor/createVendorCompanyBranch",
    updateVendorCompanyBranch: api.HOST_URI + api.URI_PREFIX + "vendor/updateVendorCompanyBranch",
    deleteBranchByCompanyId: api.HOST_URI + api.URI_PREFIX + "vendor/deleteBranchByCompanyId",
    getBranchesByCompanyId: api.HOST_URI + api.URI_PREFIX + "vendor/getBranchesByCompanyId",
    createJobDescription: api.HOST_URI + api.URI_PREFIX + "vendor/createJobDescription",
    updateJobInterviewMode: api.HOST_URI + api.URI_PREFIX + "vendor/updateJobInterviewMode",
    updateJobPosting: api.HOST_URI + api.URI_PREFIX + "vendor/updateJobPosting",
    getTransactiondata: api.HOST_URI + api.URI_PREFIX + "shared/plans/getTransactiondata",
    planInitiateOrder: api.HOST_URI + api.URI_PREFIX + "shared/plans/planInitiateOrder",
    createPlanPurchaseOrder: api.HOST_URI + api.URI_PREFIX + "shared/plans/createPlanPurchaseOrder",
    getVendorJobData: api.HOST_URI + api.URI_PREFIX + "admin/vendorMaster/getVendorJobData",
    createBureau: api.HOST_URI + api.URI_PREFIX + "vendor/bureau/createBureau",
    getBureauDetailsByVendorId: api.HOST_URI + api.URI_PREFIX + "vendor/bureau/getBureauDetailsByVendorId",
    updateBureauContactDetails: api.HOST_URI + api.URI_PREFIX + "vendor/bureau/updateBureauContactDetails",
    updateBureauAddress: api.HOST_URI + api.URI_PREFIX + "vendor/bureau/updateBureauAddress",
    uploadBureauLogo: api.HOST_URI + api.URI_PREFIX + "vendor/bureau/uploadBureauLogo",
    updateBureauSocialLinks: api.HOST_URI + api.URI_PREFIX + "vendor/bureau/updateBureauSocialLinks",
    getBranchesByBureauId: api.HOST_URI + api.URI_PREFIX + "vendor/bureau/getBranchesByBureauId",

    getReferralName: api.HOST_URI + api.URI_PREFIX + "user/getReferralName",
    createDemo: api.HOST_URI + api.URI_PREFIX + "shared/demo/createDemo",
    vendorApplicationRegistration: api.HOST_URI + api.URI_PREFIX + "admin/vendorMaster/vendorApplicationRegistration",
    getInvoiceByOrderId: api.HOST_URI + api.URI_PREFIX + "shared/plans/getInvoiceByOrderId",
    updateResumeRepositoryCandidateProfiles: api.HOST_URI + api.URI_PREFIX + "vendor/updateResumeRepositoryCandidateProfiles",
    checkUserProfile: api.HOST_URI + api.URI_PREFIX + "vendor/matri/checkUserProfile",
    createQNAs: api.HOST_URI + api.URI_PREFIX + "vendor/createQNAs",
    updateQNAs: api.HOST_URI + api.URI_PREFIX + "vendor/updateQNAs",
    getQNAs: api.HOST_URI + api.URI_PREFIX + "vendor/getQNAs",
    deleteQNAs: api.HOST_URI + api.URI_PREFIX + "vendor/deleteQNAs",
    deleteCompanyDocuments: api.HOST_URI + api.URI_PREFIX + "vendor/companyDocuments/deleteCompanyDocuments",
    checkVendorEmail: api.HOST_URI + api.URI_PREFIX + "vendor/checkVendorEmail",
    checkVendorMobile: api.HOST_URI + api.URI_PREFIX + "vendor/checkVendorMobile",
    updateCompanyTaxDetails: api.HOST_URI + api.URI_PREFIX + "vendor/updateCompanyTaxDetails",
    vendorInterviewersList: api.HOST_URI + api.URI_PREFIX + "vendor/interviewSchedule/vendorInterviewersList",
    createVendorInterviewPanel: api.HOST_URI + api.URI_PREFIX + "vendor/interviewSchedule/createVendorInterviewPanel",
    uploadMatriProfilePic: api.HOST_URI + api.URI_PREFIX + "vendor/matrimonial/uploadMatriProfilePic",
    deleteInterviewRound: api.HOST_URI + api.URI_PREFIX + "vendor/interviewSchedule/deleteInterviewRound",
    deleteVendorInterviewPanel: api.HOST_URI + api.URI_PREFIX + "vendor/interviewSchedule/deleteVendorInterviewPanel",
    shareMatriProfiles: api.HOST_URI + api.URI_PREFIX + "vendor/matri/shareMatriProfiles",
    updateCompanyDocuments: api.HOST_URI + api.URI_PREFIX + "vendor/companyDocuments/updateCompanyDocuments",
    checkMatriProfileId: api.HOST_URI + api.URI_PREFIX + "vendor/matri/checkMatriProfileId",
    checkInterviewerEmail: api.HOST_URI + api.URI_PREFIX + "vendor/interviewSchedule/checkInterviewerEmail",
    updateBureauTaxDetails: api.HOST_URI + api.URI_PREFIX + "vendor/companyDocuments/updateBureauTaxDetails",
    getPlanPurchasedFeatures: api.HOST_URI + api.URI_PREFIX + "shared/plans/getPlanPurchasedFeatures",
    getMatriSharedProfiles: api.HOST_URI + api.URI_PREFIX + "vendor/matri/getMatriSharedProfiles",
    getMembersVisitedYou: api.HOST_URI + api.URI_PREFIX + "vendor/matrimonial/getMembersVisitedYou",
    getMatriProfileAccessRequest: api.HOST_URI + api.URI_PREFIX + "vendor/matri/getMatriProfileAccessRequest",
    updateMatriProfileAccesssRequest: api.HOST_URI + api.URI_PREFIX + "vendor/matri/updateMatriProfileAccesssRequest",
    getVendorProfile: api.HOST_URI + api.URI_PREFIX + "vendor/matri/getVendorProfile",
    createBureauFollow: api.HOST_URI + api.URI_PREFIX + "vendor/bureau/createBureauFollow",
    downloadInvoiceJobsFreePlan: api.HOST_URI + api.URI_PREFIX + "user/plans/downloadInvoiceJobsFreePlan",
    applyCoupon: api.HOST_URI + api.URI_PREFIX + "shared/plans/applyCoupon",
    getBureauFollow: api.HOST_URI + api.URI_PREFIX + "vendor/bureau/getBureauFollow",
    getVendorJobsDashboard: api.HOST_URI + api.URI_PREFIX + "vendor/getVendorJobsDashboard",
    createAnonymousUser: api.HOST_URI + api.URI_PREFIX + "exam/createAnonymousUser",
    createAnonymousInterviewSchedule: api.HOST_URI + api.URI_PREFIX + "exam/createAnonymousInterviewSchedule",
    updateAnonymousInterviewSchedule: api.HOST_URI + api.URI_PREFIX + "exam/updateAnonymousInterviewSchedule",
    getAnonymousInterviewSchedule: api.HOST_URI + api.URI_PREFIX + "exam/getAnonymousInterviewSchedule",
    startExamAnonymous: api.HOST_URI + api.URI_PREFIX + "exam/startExamAnonymous",
    submitExamAnonymous: api.HOST_URI + api.URI_PREFIX + "exam/submitExamAnonymous",
    getAppearedResultsByExamCode: api.HOST_URI + api.URI_PREFIX + "exam/getAppearedResultsByExamCode",
    getVendorJobsATS: api.HOST_URI + api.URI_PREFIX + "vendor/getVendorJobsATS",
    uploadVendorDocuments: api.HOST_URI + api.URI_PREFIX + "admin/vendorMaster/uploadVendorDocuments",
    getVendorDocumentsB4Approval: api.HOST_URI + api.URI_PREFIX + "admin/vendorMaster/getVendorDocumentsB4Approval",
    getUserMatriPlans: api.HOST_URI + api.URI_PREFIX + "user/plans/getUserMatriPlans",
    initiateMatriMobileOrder: api.HOST_URI + api.URI_PREFIX + "shared/plans/initiateMatriMobileOrder",
    checkPlanValidity: api.HOST_URI + api.URI_PREFIX + "shared/plans/checkPlanValidity",
    createEmpEducation: api.HOST_URI + api.URI_PREFIX + "vendor/createEducation",
    updateEducation: api.HOST_URI + api.URI_PREFIX + "vendor/updateEducation",
    createExperience: api.HOST_URI + api.URI_PREFIX + "vendor/createExperience",
    updateExperience: api.HOST_URI + api.URI_PREFIX + "vendor/updateExperience",

    createDesignationEmp: api.HOST_URI + api.URI_PREFIX + "vendor/createDesignationEmp",
    getAllDesignationEmp: api.HOST_URI + api.URI_PREFIX + "vendor/getAllDesignationEmp",
    updateDesignationEmp: api.HOST_URI + api.URI_PREFIX + "vendor/updateDesignationEmp",
    deleteDesignationEmp: api.HOST_URI + api.URI_PREFIX + "vendor/deleteDesignationEmp",
    createDepartmentEmp: api.HOST_URI + api.URI_PREFIX + "vendor/createDepartmentEmp",
    getAllDepartmentsEmp: api.HOST_URI + api.URI_PREFIX + "vendor/getAllDepartmentsEmp",
    updateDepartmentEmp: api.HOST_URI + api.URI_PREFIX + "vendor/updateDepartmentEmp",
    deleteDepartmentEmp: api.HOST_URI + api.URI_PREFIX + "vendor/deleteDepartmentEmp",
    createShift: api.HOST_URI + api.URI_PREFIX + "vendor/createShift",
    getAllShift: api.HOST_URI + api.URI_PREFIX + "vendor/getAllShift",
    updateShift: api.HOST_URI + api.URI_PREFIX + "vendor/updateShift",
    deleteShift: api.HOST_URI + api.URI_PREFIX + "vendor/deleteShift",
    createEmpBankDetails: api.HOST_URI + api.URI_PREFIX + "vendor/createEmpBankDetails",
    updateEmpBankDetails: api.HOST_URI + api.URI_PREFIX + "vendor/updateEmpBankDetails",
    getAttendanceCalendar: api.HOST_URI + api.URI_PREFIX + "vendor/getAttendanceCalendar",
    createSalaryComponents: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/createSalaryComponents",
    updateSalaryComponent: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/updateSalaryComponent",
    deleteSalaryComponent: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/deleteSalaryComponent",
    createOrUpdateEmpAddress: api.HOST_URI + api.URI_PREFIX + "vendor/createOrUpdateEmpAddress",
    createOrUpdateEmpFamilyDetails: api.HOST_URI + api.URI_PREFIX + "vendor/createOrUpdateEmpFamilyDetails",
    getPendingLeaveRequests: api.HOST_URI + api.URI_PREFIX + "vendor/getPendingLeaveRequests",
    getAllSalaryComponents: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getAllSalaryComponents",
    getAllApprovalMgrs: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getAllApprovalMgrs",
    bulkAttendanceUpload: api.HOST_URI + api.URI_PREFIX + "vendor/bulkAttendanceUpload",
    createEmpLeaveRequests: api.HOST_URI + api.URI_PREFIX + "vendor/createEmpLeaveRequests",
    updateEmpLeaveRequestsByMgr: api.HOST_URI + api.URI_PREFIX + "vendor/updateEmpLeaveRequestsByMgr",
    getMyLeaveRequests: api.HOST_URI + api.URI_PREFIX + "vendor/getMyLeaveRequests",
    getAllHrmsEmployees: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getAllHrmsEmployees",
    updateEmpApprovalMgrs: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/updateEmpApprovalMgrs",
    createEmpSalaries: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/createEmpSalaries",
    getEmpSalaries: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getEmpSalaries",
    updateEmpSalaries: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/updateEmpSalaries",
    deleteEmpSalaries: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/deleteEmpSalaries",
    createEmpTypes: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/createEmpTypes",
    getEmpTypes: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getEmpTypes",
    updateEmpTypes: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/updateEmpTypes",
    deleteEmpTypes: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/deleteEmpTypes",
    createEmpShiftRequest: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/createEmpShiftRequest",
    getPendingShiftRequests: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getPendingShiftRequests",
    getMyShiftRequests: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getMyShiftRequests",
    approveEmpShiftRequestByMgr: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/approveEmpShiftRequestByMgr",
    getEmployeeDetailsByEmpCode: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getEmployeeDetailsByEmpCode",
    bulkHolidayCalendarUpload: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/bulkHolidayCalendarUpload",
    getStateCodesForHolidays: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getStateCodesForHolidays",
    updateStateCodesForHolidays: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/updateStateCodesForHolidays",
    bulkAttendanceCreate: api.HOST_URI + api.URI_PREFIX + "vendor/bulkAttendanceCreate",
    createEmpPassportDetails: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/createEmpPassportDetails",
    updateEmpPassportDetails: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/updateEmpPassportDetails",
    createReimbursement: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/createReimbursement",
    addItems: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/addItems",
    submitReimbursement: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/submitReimbursement",
    managerApproval: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/managerApproval",
    financeApproval: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/financeApproval",
    markAsPaid: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/markAsPaid",
    uploadAttachment: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/uploadAttachment",
    getAttachments: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getAttachments",
    deleteAttachment: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/deleteAttachment",
    getAllReimbursements: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getAllReimbursements",
    getPendingReimbursementRequests: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getPendingReimbursementRequests",
    updateEmpRequestsByMgr: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/updateEmpRequestsByMgr",
    uploadDocumentsByEmp: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/uploadDocumentsByEmp",
    getDocumentsByEmpCode: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getDocumentsByEmpCode",
    deleteDocumentById: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/deleteDocumentById",
    getPendingFinanceRequests: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getPendingFinanceRequests",
    getMyReimbursementRequests: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getMyReimbursementRequests",
    getMyFinanceRequests: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getMyFinanceRequests",
    createEmployeeLeaveType: api.HOST_URI + api.URI_PREFIX + "vendor/createEmployeeLeaveType",
    updateEmployeeLeaveType: api.HOST_URI + api.URI_PREFIX + "vendor/updateEmployeeLeaveType",
    getEmployeeLeaveType: api.HOST_URI + api.URI_PREFIX + "vendor/getEmployeeLeaveType",
    deleteEmployeeLeaveType: api.HOST_URI + api.URI_PREFIX + "vendor/deleteEmployeeLeaveType",
    createEmpOt: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/createEmpOt",
    updateEmpOt: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/updateEmpOt",
    getEmpOt: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getEmpOt",
    deleteEmpOt: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/deleteEmpOt",
    getShiftOtDetails: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getShiftOtDetails",
    cancelEmpLeaveRequest: api.HOST_URI + api.URI_PREFIX + "vendor/cancelEmpLeaveRequest",
    createEmpKpiDetails: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/createEmpKpiDetails",
    createEmpKpiHeadlines: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/createEmpKpiHeadlines",
    getEmpKpiDetails: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getEmpKpiDetails",
    createEmpKpiSubtitles: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/createEmpKpiSubtitles",
    updateEmpKpiDetails: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/updateEmpKpiDetails",
    updateEmpKpiSubtitles: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/updateEmpKpiSubtitles",
    getEvaluationFormByYear: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getEvaluationFormByYear",
    createEmpSalaryComponents: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/createEmpSalaryComponents",
    getAllEmpSalaryComponents: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getAllEmpSalaryComponents",
    createEmpShiftDetails: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/createEmpShiftDetails",
    updateReimbursementById: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/updateReimbursementById",
    createEmpSeparation: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/createEmpSeparation",
    updateEmpSeparation: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/updateEmpSeparation",
    getEmpSeparation: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getEmpSeparation",
    getPendingApprovals: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getPendingApprovals",
    managerActionSeparation: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/managerActionSeparation",
    getManagerSeparations: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getManagerSeparations",
    getHrmsDashboard: api.HOST_URI + api.URI_PREFIX + "vendor/getHrmsDashboard",
    createEmpAssetsDetails: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/createEmpAssetsDetails",
    getAssetsByCategory: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getAssetsByCategory",
    getEmpAssetsDetails: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getEmpAssetsDetails",
    updateEmpAssetsDetails: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/updateEmpAssetsDetails",
    getEmpAssets: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getEmpAssets",
    createEmpRole: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/createEmpRole",
    getEmpRoles: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getEmpRoles",
    getEvaluationEligibilityEmployees: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getEvaluationEligibilityEmployees",
    updateEmpRole: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/updateEmpRole",
    deleteEmpRole: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/deleteEmpRole",

    createEmpCategories: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/createEmpCategories",
    getEmpCategories: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getEmpCategories",
    updateEmpCategories: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/updateEmpCategories",
    deleteEmpCategories: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/deleteEmpCategories",

    createEmpAssets: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/createEmpAssets",
    deleteEmpAssets: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/deleteEmpAssets",
    updateEmpAssets: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/updateEmpAssets",
    getEmpCategoryAssetsDetails: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getEmpCategoryAssetsDetails",
    createEmpAssignedAssets: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/createEmpAssignedAssets",
    createHrmsPurchaseOrder: api.HOST_URI + api.URI_PREFIX + "shared/plans/createHrmsPurchaseOrder",
    initiateHrmsOrder: api.HOST_URI + api.URI_PREFIX + "shared/plans/initiateHrmsOrder",

    createEmpServiceCategories: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/createEmpServiceCategories",
    getEmpServiceCategories: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getEmpServiceCategories",
    updateEmpServiceCategories: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/updateEmpServiceCategories",
    deleteEmpServiceCategories: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/deleteEmpServiceCategories",

    createEmpServiceSubCategories: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/createEmpServiceSubCategories",
    getEmpServiceSubCategories: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getEmpServiceSubCategories",
    updateEmpServiceSubCategories: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/updateEmpServiceSubCategories",
    deleteEmpServiceSubCategories: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/deleteEmpServiceSubCategories",
    getActiveHRMSEmployees: api.HOST_URI + api.URI_PREFIX + "vendor/employee/getActiveHRMSEmployees",
    updateEmployee: api.HOST_URI + api.URI_PREFIX + "vendor/employee/updateEmployee",


    createEmpServiceRequest: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/createEmpServiceRequest", 
    getEmpServiceRequest: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getEmpServiceRequest", 
    getSubCategoriesByCategoryId: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getSubCategoriesByCategoryId", 
    submitEmpKpiEvaluationForm: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/submitEmpKpiEvaluationForm", 
     createCompanyProject: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/createCompanyProject",
    updateCompanyProject: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/updateCompanyProject",
    getAllCompanyProjects: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getAllCompanyProjects",
    deleteCompanyProject: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/deleteCompanyProject",
    createRtwCategories: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/createRtwCategories",
    getRtwCategories: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getRtwCategories",
    updateRtwCategories: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/updateRtwCategories",
    deleteRtwCategories: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/deleteRtwCategories",
    createEmpRtwRequest: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/createEmpRtwRequest",
    getEmpRtwRequest: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getEmpRtwRequest",
    getMyRtwRequests: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getMyRtwRequests",
    createEmpTransportRequest: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/createEmpTransportRequest",
    getEmpTransportRequest: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getEmpTransportRequest",
    approveEmpTransportRequestByMgr: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/approveEmpTransportRequestByMgr",
    getMyTransportRequests: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getMyTransportRequests",
    getPendingTransportRequests: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getPendingTransportRequests",
    getPendingRtwRequests: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getPendingRtwRequests",
    approveEmpRtwRequestByMgr: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/approveEmpRtwRequestByMgr",
    updateDesignationHierarchy: api.HOST_URI + api.URI_PREFIX + "vendor/updateDesignationHierarchy",
    uploadEmployeeRecognition: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/uploadEmployeeRecognition",
    getEmployeeRecognition: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getEmployeeRecognition",
    downloadHrmsInvoice: api.HOST_URI + api.URI_PREFIX + "user/plans/downloadHrmsInvoice",
    setApprovalMgr: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/setApprovalMgr",
    getApprovalManagers: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getApprovalManagers",
    getHrmsInvoiceByOrderId: api.HOST_URI + api.URI_PREFIX + "shared/plans/getHrmsInvoiceByOrderId",
    getEmployeesDirectory: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getEmployeesDirectory",
    getUplineManagerAndReports: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getUplineManagerAndReports",
    createSeparationCategories: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/createSeparationCategories",
    updateSeparationCategories: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/updateSeparationCategories",
    getSeparationCategories: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getSeparationCategories",
    deleteSeparationCategories: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/deleteSeparationCategories",
    

    createEmpOffBoardingChecklist: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/createEmpOffBoardingChecklist",
    updateEmpOffBoardingChecklist: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/updateEmpOffBoardingChecklist",
    getEmpOffBoardingChecklist: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getEmpOffBoardingChecklist",
    deleteEmpOffBoardingChecklist: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/deleteEmpOffBoardingChecklist",
    getSeperationEmpType: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/getSeperationEmpType",
    calculateLWD: api.HOST_URI + api.URI_PREFIX + "vendor/hrms/calculateLWD",

  },
  BLOG_APIS: {
    active_blogs: api.BLOG_API + "wp-json/custom/v1/active-blogs"
  },

  CMS_APIS: {
    getFAQs: api.CMS_API + "api/v1/getFAQs",
    getSuccessStories: api.CMS_API + "api/v1/getSuccessStories",
    getTrustedClients: api.CMS_API + "api/v1/getTrustedClients",
    getPolicyByName: api.CMS_API + "api/v1/getPolicyByName",
  },

  JOB_SEEKER_APIS: {
    validateUser: api.HOST_URI + api.URI_PREFIX + "users/validateUser",
    updateProfile: api.HOST_URI + api.URI_PREFIX + "candidateResumes/updateProfile",
    getUserQualification: api.HOST_URI + api.URI_PREFIX + "user/getUserQualification",
    addEducation: api.HOST_URI + api.URI_PREFIX + "candidateResumes/addEducation",
    createCandidateAddress: api.HOST_URI + api.URI_PREFIX + "candidateResumes/createCandidateAddress",
    updateCandidateAddress: api.HOST_URI + api.URI_PREFIX + "candidateResumes/updateCandidateAddress",
    getUserIndustries: api.HOST_URI + api.URI_PREFIX + "user/getUserIndustries",
    createOrUpdateResume: api.HOST_URI + api.URI_PREFIX + "candidateResumes/createOrUpdateResume",
    getResumePathsById: api.HOST_URI + api.URI_PREFIX + "candidateResumesPaths/getResumePathsById",
    getAllJobType: api.HOST_URI + api.URI_PREFIX + "admin/jobType/getAllJobType",
    getUserLangauges: api.HOST_URI + api.URI_PREFIX + "user/getUserLangauges",
    previewCV: api.HOST_URI + api.URI_PREFIX + "shared/plans/previewCV",
    getDashboardDetails: api.HOST_URI + api.URI_PREFIX + "users/getDashboardDetails",
    createResumePath: api.HOST_URI + api.URI_PREFIX + "candidateResumesPaths/createResumePath",
    deleteResumesPath: api.HOST_URI + api.URI_PREFIX + "candidateResumesPaths/deleteResumesPath",
    createCandidateCertification: api.HOST_URI + api.URI_PREFIX + "candidateResumes/createCandidateCertification",
    uploadAvatar: api.HOST_URI + api.URI_PREFIX + "mediaUserFiles/uploadAvatar",

    createCandidatePreferredLocations: api.HOST_URI + api.URI_PREFIX + "candidateResumes/createCandidatePreferredLocations",
    addExperience: api.HOST_URI + api.URI_PREFIX + "candidateResumes/addExperience",
    getAllResumeBuilderPlans: api.HOST_URI + api.URI_PREFIX + "user/getAllResumeBuilderPlans",
    initiateOrderResumeBuilder: api.HOST_URI + api.URI_PREFIX + "user/plans/initiateOrderResumeBuilder",
    createPurchaseOrderResumeBuilder: api.HOST_URI + api.URI_PREFIX + "user/plans/createPurchaseOrderResumeBuilder",
    getAllTransactionOrdersResumeBuilder: api.HOST_URI + api.URI_PREFIX + "user/plans/getAllTransactionOrdersResumeBuilder",
    getResumePlansPurchased: api.HOST_URI + api.URI_PREFIX + "user/plans/getResumePlansPurchased",
    generateCV: api.HOST_URI + api.URI_PREFIX + "shared/plans/generateCV",
    getJobSeekerDashboard: api.HOST_URI + api.URI_PREFIX + "user/getJobSeekerDashboard",
    createCandidateWorkLinks: api.HOST_URI + api.URI_PREFIX + "candidateResumes/createCandidateWorkLinks",
    updateCandidateWorkLinks: api.HOST_URI + api.URI_PREFIX + "candidateResumes/updateCandidateWorkLinks",
    createVisaDetails: api.HOST_URI + api.URI_PREFIX + "user/createVisaDetails",
    updateVisaDetails: api.HOST_URI + api.URI_PREFIX + "user/updateVisaDetails",
    getVisaTypeMaster: api.HOST_URI + api.URI_PREFIX + "candidateResumes/getVisaTypeMaster",
    userRegistration: api.HOST_URI + api.URI_PREFIX + "users/userRegistration",
    generateUserMobileOTP: api.HOST_URI + api.URI_PREFIX + "users/generateUserMobileOTP",
    validateUserMobileOtp: api.HOST_URI + api.URI_PREFIX + "users/validateUserMobileOtp",
    forgotPassword: api.HOST_URI + api.URI_PREFIX + "users/forgotPassword",
    getFollowedCompanies: api.HOST_URI + api.URI_PREFIX + "user/getFollowedCompanies",
    companyFollowStatus: api.HOST_URI + api.URI_PREFIX + "user/companyFollowStatus",
    companyUnfollowStatus: api.HOST_URI + api.URI_PREFIX + "user/companyUnfollowStatus",
    getSchedulesByUserId: api.HOST_URI + api.URI_PREFIX + "user/interview/getSchedulesByUserId",
    jobSaved: api.HOST_URI + api.URI_PREFIX + "jobApplied/jobSaved",
    getAllSavedJobs: api.HOST_URI + api.URI_PREFIX + "jobApplied/getAllSavedJobs",
    getAppliedJobs: api.HOST_URI + api.URI_PREFIX + "jobApplied/getAppliedJobs",
    createJobApplied: api.HOST_URI + api.URI_PREFIX + "jobApplied/createJobApplied",
    getEmailsByuserId: api.HOST_URI + api.URI_PREFIX + "shared/jobsEmailCommunication/getEmailsByuserId",
    getAllCountries: api.HOST_URI + api.URI_PREFIX + "user/country/getCountries",
    userFilterJobPosting: api.HOST_URI + api.URI_PREFIX + "jobs/userFilterJobPosting",
    getAllCollections: api.HOST_URI + api.URI_PREFIX + "getAllCollections",
    getUserQNAs: api.HOST_URI + api.URI_PREFIX + "jobs/getUserQNAs",
    generateMobileOTP: api.HOST_URI + api.URI_PREFIX + "users/generateMobileOTP",
    generateEmailOTP: api.HOST_URI + api.URI_PREFIX + "users/generateEmailOTP",
    validateEmailOtp: api.HOST_URI + api.URI_PREFIX + "users/validateEmailOtp",
    candidateResumePublish: api.HOST_URI + api.URI_PREFIX + "candidateResumes/candidateResumePublish",
    getStatesByCountryCode: api.HOST_URI + api.URI_PREFIX + "stateMaster/getStatesByCountryCode",
    getCitiesByStateId: api.HOST_URI + api.URI_PREFIX + "user/getCitiesByStateId",
    jobAppliedStatus: api.HOST_URI + api.URI_PREFIX + "jobApplied/jobAppliedStatus",

  },

  AI_APIS: {
    getSelfCoverLetter: api.AI_HOST_URI + api.AI_URI_PREFIX + "getSelfCoverLetter",

  },

  SOCKET_API: api.SOCKET_API,
  SOCKET_PATH: api.SOCKET_PATH



};
